import { createSelector } from '@ngrx/store';

import { selectConversationalChatState } from '../conversational-chat.state';

export const selectSessionId = createSelector(
  selectConversationalChatState,
  (state) => state.conversationalChatSessionId
);
